import React from "react";
import ModificaProdottiNEW from "../modificaProdotti/ModificaProdottiNEW";
import DBperDashboard from "./AreaDashboardComponenti/DBperDashboard";

function AreaDashboard({
    product,
    setProductFunction,
    utente,
    tradPermessa,
    setTradPermessa,
    setCharCount,
    charCount,
    listaNomiProdotto,
    tema
}) {


    return (
        <div className='center'>
            <div className='cf'>
                <div className="fl w-100 w-100-ns">
                {product.codiceVS === "NO DATA" && 
                
                <div className="sfondoBiancoTema">
                        <DBperDashboard
                            setProductFunction={setProductFunction}
                            utente={utente}
                            tradPermessa={tradPermessa}
                            setTradPermessa={setTradPermessa}
                            charCount={charCount}
                            setCharCount={setCharCount}
                            tema={tema}
                        />                        
                    </div>}
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    <div className="sfondoBiancoTema">
                    
                    {product.codiceVS !== "NO DATA" && 
                    
                    <ModificaProdottiNEW
                        prodotto={product}
                        setProductFunction={setProductFunction}
                        utente={utente}
                        listaNomiProdotto={listaNomiProdotto}
                        />}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AreaDashboard;